import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { FlexDiv, H1, P } from 'components/generic/HomePageComponents'
import { Button, InverseButton } from './Styled'

const Pricing = ({
  data: { header, subHeader, bodyText, buttonCTA, buttonLink, tryItCta, tryItLink, image },
  wave,
}) => (
  <FlexDiv flexDirection='column' alignItems='center' mb='70px'>
    <FlexDiv
      maxWidth='1080px'
      marginLeft={{ _: '30px', tablet: '60px' }}
      marginRight={{ _: '30px', tablet: '60px' }}
    >
      <FlexDiv flexDirection='column' ml='20px'>
        <P fontSize='16px' lineHeight='22.85px' fontWeight='400' letterSpacing='1.7px'>
          {header}
        </P>
        <GenericLazyLoadImage src={wave} width='70px' />
        <H1 fontSize={{ _: '36px', tablet: '45px' }} lineHeight='1.1' marginBottom='0px'>
          {subHeader}
        </H1>
        <P fontSize='19px' lineHeight='1.5' maxWidth='85%' marginTop='10px'>
          {bodyText}
        </P>
        <FlexDiv flexDirection={{ _: 'column', desktop: 'row' }}>
          <Button
            href={buttonLink}
            width='250px'
            fontSize='16px'
            borderColor='inverseColor'
            color='inverse'
          >
            {buttonCTA}
          </Button>
          <InverseButton href={tryItLink}>{tryItCta}</InverseButton>
        </FlexDiv>
      </FlexDiv>
      <FlexDiv alignItems='center' paddingRight='20px'>
        <FlexDiv
          backgroundImage={`url(${image})`}
          backgroundPosition='50%'
          backgroundSize='cover'
          borderRadius='50%'
          height='370px'
          margin='0 auto'
          width='350px'
          justifyContent='center'
          display={{ _: 'none', tablet: 'flex' }}
        />
      </FlexDiv>
    </FlexDiv>
  </FlexDiv>
)
export default Pricing
